import { Model } from '../../shared-features/models/model';
import { Expose } from 'class-transformer';

export class ExportDeliveryNote extends Model {
  @Expose() fileUri: string;
  @Expose() message: string;
}
